import { render, staticRenderFns } from "./CourseResources.vue?vue&type=template&id=b3f698b4&scoped=true"
import script from "./CourseResources.vue?vue&type=script&lang=js"
export * from "./CourseResources.vue?vue&type=script&lang=js"
import style0 from "./CourseResources.vue?vue&type=style&index=0&id=b3f698b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f698b4",
  null
  
)

export default component.exports